<script>
  import Modal from '@components/Modal.svelte';
  import SearchBar from '@app-components/SearchBar.svelte';
  import { getGroupStore } from '@stores/group';
  let searchTermStore = getGroupStore('searchTermStore');
  import RecObject from '@app-components/RecObject.svelte';
  import jQuery from 'jquery';

  export let showModal = false;
  export let group;
  const mobile = false;
  let searched;
  let searchResults = [];
  let loadingSearch;

  jQuery(window).keydown(function (e) {
    if ((e.ctrlKey || e.metaKey) && e.keyCode === 70) {
      if (!showModal) {
        e.preventDefault();
        showModal = true;
      }
    }
  });
</script>

<style style="text/scss" lang="scss">
  * :global(.modal__container) {
    position: absolute !important;
    right: 0 !important;
    top: 0 !important;
    height: 100% !important;
    margin: 0px !important;
  }
  * :global(.modal__overlay) {
    background: rgba(0, 0, 0, 0.07) !important;
  }
  * :global(.modal__content) {
    margin-top: -3.5rem !important;
  }
  * :global(.ui-search) {
    width: 92% !important;
    margin-bottom: 20px !important;
  }
</style>

{#if showModal}
  <div class="svelte-modal">
    <Modal
      mobile={false}
      on:close={() => {
        searchTermStore.set({ term: '' });
        searchResults = [];
        showModal = false;
      }}
      bodyScrollable={true}
      show={showModal}
      showCloseButton={true}
      fadeInDuration={200}
      style="border-radius: 0px; width: 540px">
      <div slot="content" class:mobile={mobile}>
        <SearchBar
          clearText={'Clear'}
          group={group}
          bind:searched={searched}
          bind:searchResults={searchResults}
          bind:loading={loadingSearch}
          focus={true} />
        <div class="grid-content">
          {#if searched}
            {#if loadingSearch}
              <div />
            {:else if searchResults.length == 0}
              <div
                style="margin-top: 64px; color: var(--neutral-gray-light, #B3B3B3);
                text-align: center;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                width: 260px;
                margin-left: auto;
                margin-right: auto;
                line-height: 24px;">
                <div>No results found - check your</div>
                <div>search for typos and try again!</div>
              </div>
            {:else}
              <div
                style="color: var(--neutral-gray, #7F7F7F);
                text-align: left;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 24px; ">
                {searchResults.length} result{searchResults.length > 1 ? 's' : ''}
              </div>
              <div
                style="display: flex; margin-top: 25px; justify-content: center; flex-wrap: wrap; margin-left: -10px; margin-right: -10px;">
                {#each searchResults as recObject}
                  <div style="margin: 10px">
                    <RecObject id={recObject.id} showActionBar={true} />
                  </div>
                {/each}
              </div>
            {/if}
          {/if}
        </div>
      </div>
    </Modal>
  </div>
{/if}
